import Swiper, { Navigation, Pagination, Lazy, Keyboard } from 'swiper';
import 'swiper/swiper-bundle.css';

function propertyPhotosSlider({ document }) {
  Swiper.use([Navigation, Pagination, Lazy, Keyboard]);
  return new Swiper('.swiper-card-container', {
    touchEventsTarget: 'wrapper',
    slidesPerView: 1,
    loop: false,
    preloadImages: false,
    lazy: false,
    pagination: {
      el: '.swiper-pagination',
      dynamicBullets: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }
  });
}

export default propertyPhotosSlider;
